import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';
import {
  ShiftTimelineInteractionsState,
  ShiftTimelineSettingsState,
  ShiftTimelineState,
} from '@wilson/shift-timeline/state';
import { Observable, combineLatest, map } from 'rxjs';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import { DemarcatorRange } from '@wilson/interfaces';
import { AbsenceDrawerHelperService } from '@wilson/non-domain-specific/absence';
import { ShiftDrawerService } from '../../services/shift-drawer.service';

@Component({
  selector: 'wilson-demarcator-lines',
  imports: [CommonModule],
  templateUrl: './demarcator-lines.component.html',
  styleUrls: ['./demarcator-lines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemarcatorLinesComponent implements OnInit {
  private store = inject(Store);
  private readonly absenceDrawerHelperService = inject(
    AbsenceDrawerHelperService,
  );
  private viewContainerRef = inject(ViewContainerRef);
  private shiftDrawerService = inject(ShiftDrawerService);
  readonly dragAndDropModeService = inject(DragAndDropModeService);

  @Input()
  set scrollLeftPx(value: number) {
    this.viewContainerRef.element.nativeElement.scrollLeft = value;
  }

  public frameLength$!: Observable<number>;
  public resourcesColumnWidthPx$!: Observable<number>;
  public isDrawerVisible$!: Observable<boolean>;
  public demarcatorRange$!: Observable<DemarcatorRange>;

  async ngOnInit(): Promise<void> {
    this.frameLength$ = this.store.select(ShiftTimelineState.frameLength);
    this.resourcesColumnWidthPx$ = this.store.select(
      ShiftTimelineSettingsState.resourcesColumnWidthPx,
    );
    this.store.select(ShiftTimelineSettingsState.resourcesColumnWidthPx);
    this.demarcatorRange$ = this.store.select(
      ShiftTimelineInteractionsState.getDemarcatorRange,
    );

    this.isDrawerVisible$ = combineLatest([
      this.shiftDrawerService.isDrawerVisible$,
      this.absenceDrawerHelperService.isAbsenceDrawerVisible$,
    ]).pipe(
      map(
        ([shiftDrawer, absenceDrawerVisible]: [boolean, boolean]) =>
          shiftDrawer || absenceDrawerVisible,
      ),
    );
  }
}
